const CONFIG = {
  background_colour: 0x000000,
  // background_image: { x: 840, y: 360, sheet: 'background_welcome', frame: false },
  // logo: { x: 840, y: 150, sheet: 'background_welcome', frame: false },
  bar_x: 840,
  bar_y: 360,
  bar_width: 600,
  bar_height: 30,
  bar_track: 0x505050,
  bar_fill: 0xcccccc,
};

export class LoaderScene extends Phaser.Scene {
  init(config = {}) {
    config = { ...CONFIG, ...config };

    if (config.background_colour) this.add.rectangle(840, 360, 1680, 720, config.background_colour);
    if (config.background_image)
      this.add.image(
        config.background_image.x,
        config.background_image.y,
        config.background_image.sheet,
        config.background_image.frame
      );
    if (config.logo)
      this.add.image(config.logo.x, config.logo.y, config.logo.sheet, config.logo.frame);

    this.add
      .rectangle(
        config.bar_x - config.bar_width * 0.5,
        config.bar_y,
        config.bar_width,
        config.bar_height,
        config.bar_track
      )
      .setOrigin(0, 0.5);

    this.bar = this.add
      .rectangle(
        config.bar_x - config.bar_width * 0.5,
        config.bar_y,
        config.bar_width,
        config.bar_height,
        config.bar_fill
      )
      .setOrigin(0, 0.5);

    if (config.bar_border_colour) {
      const g = this.add.graphics();
      g.setPosition(config.bar_x - config.bar_width * 0.5, config.bar_y - config.bar_height * 0.5);
      g.lineStyle(config.bar_border_width || 1, config.bar_border_colour);
      g.strokeRect(0, 0, config.bar_width, config.bar_height);
      this.add(g);
    }
  }

  setProgress(value) {
    if (this.bar) this.bar.scaleX = Phaser.Math.Clamp(value, 0, 1);
  }
}
